import { AlertTriangleIcon } from '@langchain/untitled-ui-icons';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import Typography from '@mui/joy/Typography';

import { useDeleteOrgScopedApiKeyMutation } from '@/hooks/useSwr';

interface DeleteModalProps {
  isOpen: boolean;
  doClose: () => void;
  type: 'service' | 'pat';
  keyId: string;
}

export function DeleteKeyModal({
  keyId,
  type,
  isOpen,
  doClose,
}: DeleteModalProps) {
  const deleteKey = useDeleteOrgScopedApiKeyMutation(keyId, type, {
    onSuccess: doClose,
  });

  return (
    <Modal open={isOpen} onClose={() => doClose()}>
      <ModalDialog
        variant="outlined"
        role="alertdialog"
        aria-labelledby="alert-dialog-modal-title"
        aria-describedby="alert-dialog-modal-description"
      >
        <Typography
          id="alert-dialog-modal-title"
          component="h2"
          startDecorator={<AlertTriangleIcon className="size-4" />}
        >
          Confirmation
        </Typography>
        <Divider />
        <Typography
          id="alert-dialog-modal-description"
          textColor="text.tertiary"
        >
          Are you sure you want to delete this key?
        </Typography>
        <Box
          sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', pt: 2 }}
        >
          <Button
            variant="soft"
            color="neutral"
            onClick={(e) => {
              e.stopPropagation();
              doClose();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="solid"
            color="danger"
            loading={deleteKey.isMutating}
            onClick={async () => {
              await deleteKey.trigger({});
              doClose();
            }}
          >
            Delete
          </Button>
        </Box>
      </ModalDialog>
    </Modal>
  );
}
